import React from "react";

const Career = () => <h1 className="page-title">Career Page</h1>;

export default Career;